import { Link } from "react-router-dom";
import tw from "tailwind-styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
export const CardsContainer = tw.div`
  flex
  gap-5
  justify-around
  md:justify-start
  flex-row
  flex-wrap
  w-full
`;
export const BasicCard = tw.div`
  w-[343px]
  rounded-3xl
  bg-white
  shadow-lg
  overflow-hidden
  a > {
    hover:opacity-90 transition hover:shadow-none
  }
  `;
export const CardHeader = tw.div`
  w-full
`;
export const CardContent = tw.div`
  p-4
  space-y-4
`;
export const CardTitle = tw.div`
  w-full
  text-[24px]
  font-medium
  truncate
  pb-1
`;
export const CardDescription = tw.div`
  text-sm
  md:text-base
  text-ellipsis
  line-clamp-4
  text-grey-400
  leading-relaxed
`;
export const CardFooter = tw.div`
  absolute
  bottom-0
  inset-x-0
  bg-zinc-50
  h-20
  w-full
`;
export const CardFooterContent = tw.div`
  flex
  flex-row
  items-center
  h-full
  w-full
  `;
const colorMap = {
  blue: "bg-blue-100",
  green: "bg-green-100",
  grey: "bg-grey-100",
  yellow: "bg-yellow-100",
  orange: "bg-orange-100",
  rainbow: "bg-rainbow-gradient"
};
const roundedMap = {
  full: "rounded-full",
  lg: "rounded-lg",
  "3xl": "rounded-3xl"
};
export const Badge = tw.div`
  font-mono
  text-xs
  text-gray-900
  bg-gray-100
  whitespace-nowrap
  inline-flex
  max-w-full
  w-fit
  items-center
  px-2
  py-1.5
  ${p => {
  var _p$color;
  return colorMap[(_p$color = p.color) !== null && _p$color !== void 0 ? _p$color : "grey"];
}}
  ${p => {
  var _p$rounded;
  return roundedMap[(_p$rounded = p.rounded) !== null && _p$rounded !== void 0 ? _p$rounded : "lg"];
}}
  ${p => p.disabled ? "opacity-50" : ""}
  `;
export const Tabs = tw.div`
flex
text-lg
md:text-xl
border-b-4
border-blue-100
gap-4
`;
export const Tab = _ref => {
  let {
    active,
    show,
    ...linkProps
  } = _ref;
  return /*#__PURE__*/_jsx(Link, {
    className: `
  py-3
  px-6
  border-b-4
  border-blue-100
  rounded-t-2xl
  -mb-1
  ${show ? "" : "hidden"}
  ${active ? `font-bold bg-blue-100 border-orange-100` : ""}
  `,
    ...linkProps
  });
};